import React, { useState } from "react";
import ProgressBar from "../Common/ProgressBar";
import RadioButton from "../../../UI/RadioButton";
import AnalyzeModal from "../../Layouts/Split_1/AnalayzeModal";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
const Bankruptcy = ({
  className,
  slideChange,
  textHeadingLine1,
  textHeadingLine2,
  validation,
  backClick,
}) => {
  const [checkedOne, setCheckedOne] = useState("unchecked");
  const [checkedTwo, setCheckedTwo] = useState("unchecked");
  const nextSlide = async (e) => {
    handleShowFirst();
    setTimeout(() => {
      handleCloseFirst();
      handleShowSecond();
    }, 3000);
    setTimeout(() => {
      handleCloseSecond();

      if (e.target.value === "21") {
        setCheckedOne("checked");
        slideChange(e);
      } else {
        setCheckedOne("unchecked");
      }

      if (e.target.value === "22") {
        setCheckedTwo("checked");
        slideChange(e);
      } else {
        setCheckedTwo("unchecked");
      }
      slideChange(e);
    }, 6000);
  };
  const [showFirstModal, setShowFirstModal] = useState(false);
  const handleShowFirst = () => setShowFirstModal(true);
  const handleCloseFirst = () => setShowFirstModal(false);

  const [showSecondModal, setShowSecondModal] = useState(false);
  const handleShowSecond = () => setShowSecondModal(true);
  const handleCloseSecond = () => setShowSecondModal(false);
  return (
    <>
      <div id="slide-9" className={`${className}`}>
        <ProgressBar value="70" />

        <h3> {textHeadingLine1} </h3>
        <h4> {textHeadingLine2} </h4>
        <div className="radio_buttons">
          <RadioButton
            value="21"
            name="bankruptcy"
            className="radio regNextBtn"
            labelName="Yes"
            labelClassName={`radio ${checkedOne}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <RadioButton
            value="22"
            name="bankruptcy"
            className="radio regNextBtn"
            labelName="No"
            labelClassName={`radio ${checkedTwo}`}
            onClick={nextSlide}
            validation={validation()}
          />
        </div>
        <p className="text-center">
          <span
            className="back-btn btn btn-link"
            name="back08"
            children="<< Previous"
            onClick={backClick}
          ></span>
        </p>
      </div>
      <Modal
        show={showFirstModal}
        onHide={handleCloseFirst}
        backdrop="static"
        keyboard={false}
        className="formmodal"
        contentClassName="modalcontent"
      >
        <Modal.Body className="modal-bordr">
          <div id="slide7" className="col-12 slide-pad text-center">
            <div className="form-group text-center" id="analize1">
              <h2>Analysing Your Results</h2>
              <img src="/assets/img/MB_UBRF_1_1/review.gif" alt="" />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showSecondModal}
        onHide={handleCloseSecond}
        backdrop="static"
        keyboard={false}
        className="formmodal"
        contentClassName="modalcontent"
      >
        <Modal.Body className="modal-bordr">
          <div id="slide7nxt" className="col-12 slide-pad text-center">
            <div className="form-group text-center" id="analize1">
              <h2>Good News! </h2>
              <p>
                We are able to assist you further. Please give us some back
                information. <br />
                (This will only take 1 minute)
              </p>
              <img src="/assets/img/MB_UBRF_1/review.gif" alt="" />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Bankruptcy;
